import Utils from '@/scripts/Utils';
import ConsumptionApi from '@/services/apiPdf/ConsumptionApi.js';
import UsersService from "@/services/server/UsersService";
import UnitsService from "@/services/server/UnitsService";
import SectorsServiceServer from '@/services/server/SectorsService';
import ChartConsumption from "@/components/charts/ChartsConsumption/Consumption.vue";
import ConsumptionFunctions from "@/pages/Consumption/ConsumptionFunctions.js"
import KpiCard from "@/components/KPI/KpiCard.vue";
import ConsumptionService from "@/services/server/ConsumptionService.js";
import ConsumptionBarChart from "@/components/charts/ConsumptionBarChart.vue";
import Rules from "@/utils/Rules";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import debounce from 'lodash/debounce';
import { mapGetters } from 'vuex';
import store from '@/store/index'
var { DateTime } = require("luxon");

const PROJECT_START_YEAR = '2020'
const MONTH = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"]

import { generateXLSX } from "./ReportEconomyXLSX";

export default {

  name: "Consumption",

  components: {
    ConsumptionBarChart,
    //ChartConsumption,
    KpiCard
  },


  data() {
    return {
      unitsDataGraphic: [],
      summedGraphs: [],
      selectsLoading: {
        client: false,
        unit: false,
        sector: false
      },
      consultDatalLoading: {
        graphicButton: false,
        readingButton: false,
      },
      totalConsumptionUnitsSelected: false,
      groupingDataGraphic: false,
      monthListIndex: [],
      isDataGraphic: true,
      menuDateStart: false,
      menuDateEnd: false,
      dateFormattedSelectedPreviewStart: '',
      dateFormattedSelectedPreviewEnd: '',
      dateSelectedPreviewStart: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      dateSelectedPreviewEnd: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      lastReadingDate: '',
      previewDateCurrent: '',
      previewDate: null,
      dateSelectedEnd: '',
      data_abstract_client: {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      },
      readings_table_table1: [],
      readings_table_table2: [],
      loadButtonPdf: false,
      listClients: [],
      selectedClient: null,
      listUnits: [],
      selectedUnits: [],
      listSectors: [],
      selectedSector: [],
      readings: [],
      optionMetric: true,
      switch1: "Metros Cúbicos (m³)",
      validDayPeriodSelected: true,
      validHourPeriodSelected: true,
      validMonthPeriodSelected: true,
      consultReading: false,
      optionsToDisplay: [{ label: "Dia", value: "day" }],
      optionToDisplaySelected: "day",
      totalEstimatedConsumption: [],
      dateFormattedSelectedStart: '',
      dateFormattedSelectedEnd: '',
      kpiTipWater: 'Nomenclatura usada pela concessionária local para indicar o consumo de água registrado.',
      kpiTipSewage: 'Nomenclatura usada pela concessionária local para indicar o volume de esgoto registrado.',
      kpiTipGeneral: 'Nomenclatura usada pela concessionária local para indicar o volume de água e esgoto registrado.',
      dateSelectedFormatted: Utils.formatDate(new Date(), "<dd>/<MM>/<YYYY>"),
      dateSelectedStart: '',
      dateSelected: Utils.formatDate(new Date(), "<YYYY>-<MM>-<dd>"),
      menuDate: false,
      byMonth: MONTH,
      byYear: Utils.generateYearsByInterval(PROJECT_START_YEAR, 'now').map((date) => Utils.getDateInfo(date, false)['year']),
      monthSelected: MONTH[new Date().getMonth()],
      yearSelected: new Date().getFullYear(),
      optionPeriod: 'Últimos 7 dias',
      consultGraph: false,
      consultTable: false,
      graphicFlag: false,
      isDataTable: false,
      headers_tabledays: [
        { text: 'Data', align: 'center', sortable: false, value: 'date' },
        { text: 'Medição', value: 'value', align: 'center', },
      ],
      readings_table: [],
      monthListIndex: {
        Janeiro: { month: 1 },
        Fevereiro: { month: 2 },
        Março: { month: 3 },
        Abril: { month: 4 },
        Maio: { month: 5 },
        Junho: { month: 6 },
        Julho: { month: 7 },
        Agosto: { month: 8 },
        Setembro: { month: 9 },
        Outubro: { month: 10 },
        Novembro: { month: 11 },
        Dezembro: { month: 12 }
      },
      loadingReadings: false,
      dateOptions: {
        startDate: DateTime.utc()
          .setZone("America/Sao_Paulo")
          .startOf("day")
          .toSeconds(),
        endDate: DateTime.utc().setZone("America/Sao_Paulo").toSeconds(),
        mode: "day",
      },
      chartMenuItems: ["Últimos 7 dias", "Por mês", "Por dia", "Por hora", "Por intervalo", "Período de leitura estimado"],
      dialog: false,
      showNextReading: false,
      nextDateFormated: '',
      resume: {},
      totalDates: 0,
      permittedStartDate: null,
      permittedEndDate: null,
      selectsModal: false,
      validForm: true,
      fileLink: null,
      dialogDownload: false,
      unitSelectedDataKPIs: {},
      goalMonth: null,
      averageBeforeFozRaw: undefined,
      adjustedAverage: undefined,
      adjustedGoalEconomy: undefined,
      metaEconomy: undefined,
      exporting: false,
      recordedConsumption: null,
      recordedConsumptionRaw: null,
      isKPI: true,
      goalEconomy: '',
      generatingChart: false,
      dynamicHeight: '70vh',
      selectedUnitSum: [],
      selectedPeriod: '',
      averageConsumption: '',
      estimatedTotal: undefined,
      // Tooltips dos KPIs
      kpiRecordedConsumptionTip: 'Representa o consumo total efetivamente medido (água + efluentes) no período selecionado.',
      kpiAverageConsumptionTip: 'Média de consumo diário no período selecionado, calculada a partir das leituras disponíveis.',
      kpiEstimatedTotalTip: 'Estimativa de consumo para o período completo, considerando medições já realizadas e projeções calculadas quando houver dias ou horários futuros selecionados.',
    };
  },

  computed: {
    ...mapGetters([
      'getSelectedUnit',
      'getSelectedSectors',
      'getSelectedUnits',
    ]),
    unitMeasureVuex() {
      return this.$store.getters.unitMeasure;
    },
    selectedPeriodValueVuex() {
      return this.$store.getters.selectedPeriodValue;
    },
    rulesRequiredArray() {
      return [this.requiredRuleArray()]
    },
    getNameByIdClient() {
      const client = this.listClients.find(({ id }) => id === this.selectedClient)
      return client ? client.name : ""
    },
    rulesRequired() {
      return Rules.required();
    },
    isCubicMetersSelected() {
      return this.switch1 == 'Metros Cúbicos (m³)'
    },
    isLitersSelected() {
      return !this.isCubicMetersSelected
    },
    unitMeasurement() {
      return this.isCubicMetersSelected ? 'cubic_meter' : 'liters'
    },
    likesAllUnits() {
      return this.selectedUnits.length === this.listUnits.length
    },
    likesSomeUnits() {
      return this.selectedUnits.length > 0 && !this.likesAllUnits
    },
    iconUnitSelect() {
      if (this.likesAllUnits) return 'mdi-close-box'
      if (this.likesSomeUnits) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    likesAllSectors() {
      return this.selectedSector.length === this.listSectors.length
    },
    likesSomeSectors() {
      return this.selectedSector.length > 0 && !this.likesAllSectors
    },
    iconSectorSelect() {
      if (this.likesAllSectors) return 'mdi-close-box'
      if (this.likesSomeSectors) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    consumptionType() {
      if (!this.unitSelectedDataKPIs || this.unitSelectedDataKPIs.consumptionType === undefined) {
        return ['', ''];
      }
      return this.unitSelectedDataKPIs.consumptionType.split('/');
    },
  },

  methods: {
    formatConsumption(valueM3) {
      if (valueM3 == null || isNaN(valueM3)) return '-';

      if (this.unitMeasureVuex === 'liters') {
        return `${Math.round(valueM3 * 1000).toLocaleString('pt-BR')} L`;
      }

      return `${valueM3.toLocaleString('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })} M³`;
    },

    resetStateForEstimated() {
      // Limpa seleções
      this.selectedUnits = [];
      this.selectedUnitSum = [];
      this.selectedSector = [];
      this.listSectors = [];

      // Limpa dados calculados
      this.resume = {};
      this.readings = [];
      this.estimatedTotal = undefined;

      // Reseta estados visuais
      this.isDataGraphic = false;
      this.isDataTable = false;
      this.consultGraph = false;
      this.consultTable = false;
      this.generatingChart = false;

      // Reseta datas para evitar reaproveitamento inválido
      this.dateOptions = {
        startDate: null,
        endDate: null,
        mode: this.optionToDisplaySelected || 'day'
      };
    },

    formatLabelByMode(date) {
      if (this.dateOptions.mode === 'hour') {
        return `${date.getHours().toString().padStart(2, '0')}:00`;
      } else if (this.dateOptions.mode === 'month') {
        const monthNames = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear().toString().slice(-2);
        return `${month}/${year}`;
      } else {
        // day mode (padrão)
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}`;
      }
    },
    findSelectedSectorDetails(sectorId) {
      const sectors = Array.isArray(this.selectedSector) ? this.selectedSector : [this.selectedSector];
      return sectors.find((sector) =>
        sector?.id_doc === sectorId
        || sector?.id === sectorId
        || sector?.idDoc === sectorId
      ) || null;
    },
    buildSectorResumeEntryFromApiResponse(sectorConsumption) {
      const toM3 = (value = 0) => (Number(value) || 0) / 1000;
      const sector = this.findSelectedSectorDetails(sectorConsumption?.sector_id);
      const key = sector?.id_modem || sectorConsumption?.sector_id;
      const safeConsumptions = Array.isArray(sectorConsumption?.consumptions)
        ? sectorConsumption.consumptions
        : [];
      const labels = safeConsumptions.map((consumption) => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });

      return {
        key,
        resume: {
          modemId: key,
          total_liters: Number(sectorConsumption?.measured_consumption) || 0,
          total_cubic_meters: toM3(sectorConsumption?.measured_consumption),
          average_liters: Number(sectorConsumption?.average_current_consumption) || 0,
          average_cubic_meters: toM3(sectorConsumption?.average_current_consumption),
          estimative_total_liters: Number(sectorConsumption?.estimated_total_consumption) || 0,
          estimative_total_cubic_meters: toM3(sectorConsumption?.estimated_total_consumption),
          measured_total: toM3(sectorConsumption?.measured_consumption),
          estimated_total: toM3(sectorConsumption?.estimated_total_consumption),
          average: toM3(sectorConsumption?.average_current_consumption),
          readings: safeConsumptions.map((consumption) => {
            const date = new Date(consumption.time);
            const waterLiters = Number(consumption?.value) || 0;
            const waterM3 = toM3(waterLiters);
            return {
              label: this.formatLabelByMode(date),
              water: waterM3,
              water_liters: waterLiters,
              water_cubic_meters: waterM3,
              date,
              isEstimative: Boolean(consumption?.isEstimative),
            };
          }),
          labels,
          modem: sector,
          modemName: sector?.name || sector?.sectorName || sector?.modemName || 'Desconhecido',
          unitMeasurement: 'cubic_meter',
          waterSupplyType: sectorConsumption?.waterSupplyType,
          invoiced: sectorConsumption?.invoiced,
        },
      };
    },
    async generateSectorConsumptionFromApi(startDate, endDate, sectors = []) {
      const sectorIds = (Array.isArray(sectors) ? sectors : [])
        .map((sector) => sector?.id_doc || sector?.id || sector?.idDoc)
        .filter(Boolean);

      if (!sectorIds.length) {
        const labels = ConsumptionFunctions.createLabels(startDate, endDate, this.dateOptions.mode);
        const { permittedStartDate, permittedEndDate } = ConsumptionFunctions.checkPeriod(labels, this.dateOptions.mode);
        return { permittedStartDate, permittedEndDate, resume: {}, labels };
      }

      const adjustedEndDate = this.selectedPeriod !== 'hour'
        ? new Date(endDate.getTime() - 24 * 60 * 60 * 1000)
        : endDate;

      const response = await ConsumptionService.findBySectors({
        start_date: startDate,
        end_date: adjustedEndDate,
        mode: this.dateOptions.mode,
        unit_measurement: 'liters',
        sector_ids: sectorIds,
      });
      const sectorsData = Array.isArray(response?.data?.data) ? response.data.data : [];
      const resume = sectorsData.reduce((acc, sectorConsumption) => {
        const entry = this.buildSectorResumeEntryFromApiResponse(sectorConsumption);
        if (entry.key) acc[entry.key] = entry.resume;
        return acc;
      }, {});
      const labels = sectorsData[0]?.consumptions?.map((consumption) => {
        const date = new Date(consumption.time);
        return {
          date,
          liters: 0,
          label: this.formatLabelByMode(date),
        };
      }) || ConsumptionFunctions.createLabels(startDate, endDate, this.dateOptions.mode);
      const { permittedStartDate, permittedEndDate } = ConsumptionFunctions.checkPeriod(labels, this.dateOptions.mode);

      return { permittedStartDate, permittedEndDate, resume, labels };
    },
    toStringSafe(val) {
      return val == null ? '' : String(val);
    },
    requiredRuleArray(errorText = 'Campo requerido') {
      return value => value === null || !value.length ? errorText : true;
    },
    async syncSelectedSectorsFromVuex() {
      // Na tela de consumo, ignorar setores do tipo RESERVOIR mesmo que venham do Vuex
      const vuexSectors = (this.getSelectedSectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );
      if (!vuexSectors.length) {
        this.selectedSector = [];
        return;
      }
      this.selectedSector = vuexSectors;
      const unitIds = [...new Set(vuexSectors.map(s => s.id_unit))];
      this.selectedUnits = unitIds;
      if (unitIds.length) {
        await this.getSectorsByUnitId(unitIds);
      }
      const missingSectors = vuexSectors.filter(s => !this.listSectors.some(ls => ls.id_doc === s.id_doc));
      if (missingSectors.length) {
        this.listSectors = [...this.listSectors, ...missingSectors];
      }
      await this.onChangeSector(this.selectedSector);
      this.consultConsumptionGraphic()
    },
    async getSectorsByUnitFromServer(unitId) {
      if (!unitId) return [];

      try {
        const response = await SectorsServiceServer.findByUnit(unitId);
        const sectors = response?.data?.data;
        return Array.isArray(sectors) ? sectors : [];
      } catch (error) {
        console.warn(`Não foi possível buscar os setores da unidade ${unitId} pelo backend`, error);
        return [];
      }
    },
    /**
     * Ao entrar na página de Consumo com alguma unidade já selecionada na RightSidebar,
     * garante que os setores visíveis (não RESERVOIR) dessa unidade sejam selecionados
     * caso ainda não exista nenhum setor selecionado.
     */
    async ensureSectorsForSelectedUnitIfMissing() {
      const selectedUnit = this.getSelectedUnit;
      if (!selectedUnit) return;

      const vuexSectors = (this.getSelectedSectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );

      // Se já existem setores (não reservatório) selecionados no Vuex, não faz nada
      if (vuexSectors.length > 0) {
        return;
      }

      // Busca setores da unidade selecionada e seleciona todos os setores visíveis
      const sectors = await this.getSectorsByUnitFromServer(selectedUnit.id);
      const visibleSectors = (sectors || []).filter(
        (s) => s.waterSupplyType !== 'RESERVOIR'
      );

      if (!visibleSectors.length) {
        this.selectedSector = [];
        return;
      }

      this.listSectors = visibleSectors;
      this.selectedSector = [...visibleSectors];
      this.selectedUnits = [selectedUnit.id];

      // Mantém Vuex sincronizado com a seleção feita aqui
      try {
        if (store && typeof store.dispatch === 'function') {
          await store.dispatch('setSelectedSectors', this.selectedSector);
          await store.dispatch('setSelectedUnits', [{ ...selectedUnit, unit: selectedUnit }]);
        }
      } catch (e) {
        console.warn('Não foi possível sincronizar setores/unidades com o Vuex:', e);
      }

      this.onChangeSector(this.selectedSector);
    },
    toggleSectorsList() {
      this.$nextTick(() => {
        if (this.likesAllSectors) {
          this.selectedSector = []
        } else {
          this.selectedSector = this.listSectors.slice()
        }
        this.onChangeSector(this.selectedSector)
      })
    },
    toggleUnitsList() {
      this.$nextTick(() => {
        if (this.likesAllUnits) {
          this.selectedUnits = []
        } else {
          this.selectedUnits = this.listUnits.slice().map((unit => unit.id))
        }
        this.onChangeUnit(this.selectedUnits)
      })
    },
    onKeydownSector(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedSector = [];
      }
    },
    onChangeSector(sector) {
      this.readings_table = []
      this.groupingDataGraphic = false

      this.isDataGraphic = false;
      this.isDataTable = false;
    },
    onKeydownUnit(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedUnits = [];
        this.selectedSector = [];
        this.listSectors = [];
      }
    },
    async getSectorsByUnitId(idUnits) {
      const execFuncs = idUnits.map(id => this.getSectorsByUnitFromServer(id))

      await Promise.all(execFuncs).then((values) => {
        // Em consumo, a lista de setores não deve incluir reservatórios
        const allSectors = values.flatMap(value => Array.isArray(value) ? value : []);
        this.listSectors = allSectors.filter(
          (sector) => sector.waterSupplyType !== 'RESERVOIR'
        );
      })
    },
    async onChangeUnit(unitData) {
      this.listSectors = [];
      //this.selectedSector = [];
      this.selectsLoading.sector = true
      // await this.getSectorsByUnitId(idUnits)
      this.closeInfoData();
      this.onChangeInfoUnit(unitData)
      //this.selectedSector = [];
      this.selectsLoading.sector = false
      if (this.listSectors.length === 1) this.selectedSector = this.listSectors;
    },
    onKeydownClient(key) {
      if (key.code === 'Backspace') {
        this.closeInfoData();
        this.selectedClient = [];
        this.selectedUnits = [];
        this.listUnits = [];
        this.selectedSector = [];
        this.listSectors = [];
      }
    },
    async onChangeClient(idClient) {
      this.selectsLoading.unit = true
      this.closeInfoData();
      this.selectedUnits = [];
      this.selectedSector = [];
      this.showNextReading = false;

      const response = await UnitsService.findAllByClient(idClient)
      this.listUnits = response.data.data
      this.selectsLoading.unit = false
      if (this.listUnits.length === 1) {
        this.selectedUnits = [this.listUnits[0].id];
        this.onChangeUnit(this.selectedUnits);
      }
    },

    async exportSheets() {
      if (!this.getSelectedUnit) {
        showInfoSnackBar("Selecione uma unidade para gerar a planilha")
        return
      }
      if (!this.checkSameUnit()) {
        showInfoSnackBar("Selecione apenas uma unidade para gerar a planilha")
        return
      }
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;
      if (!this.selectedSector.length) {
        showInfoSnackBar("Selecione ao menos um setor para gerar a planilha")
        return
      }
      this.exporting = true
      const currentResume = { ...this.resume };
      const currentReadings = [...this.readings];
      const currentIsDataGraphic = this.isDataGraphic;
      const currentIsDataTable = this.isDataTable;
      // Bloqueio: não permitir exportar múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível exportar múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        this.exporting = false
        return
      }

      await this.generateAllConsumption(true)
      let excelData = {
        unit_name: this.getSelectedUnit?.title || this.getSelectedUnit?.name || 'Unidade',
        sectors: []
      }
      let totalWater = 0;
      let resumeValues = Object.entries(this.resume)
        .filter(([key, _]) => key !== 'goal')
        .map(([_, value]) => value)
      for (let i = 0; i < resumeValues.length; i++) {
        let resume = resumeValues[i]
        let modemName = resume['modemName']
        let rows = []
        rows.push(modemName)
        resume.readings.forEach(
          (reading) => {
            totalWater += reading.water;
            let row = [reading.label, (reading.water * 1000).toFixed(0), reading.water.toFixed(3).replace('.', ',')]
            rows.push(row)
          }
        )
        let lastRow = ['Total', (totalWater * 1000).toFixed(0), totalWater.toFixed(3).replace('.', ',')]
        rows.push(lastRow)
        excelData.sectors.push(rows)
      }
      await generateXLSX(excelData)

      this.resume = currentResume;
      this.readings = currentReadings;
      this.isDataGraphic = currentIsDataGraphic;
      this.isDataTable = currentIsDataTable;
      this.exporting = false
    },
    estimatedConsumption(total, estimated) {
      let sum = total + estimated
      return sum.toFixed(2)
    },

    getEstimatedTotal(resume) {
      if (!resume || typeof resume !== 'object') {
        return 0;
      }
      const keys = Object.keys(resume).filter(key => key !== 'goal');
      if (keys.length === 0) {
        return 0;
      }
      let totalEstimated = 0;

      for (const key of keys) {
        const item = resume[key];

        // Verifica se é um resume de unidade (tem estimatedTotal já calculado)
        if (item.hasOwnProperty('estimatedTotal') && typeof item.estimatedTotal === 'number') {
          // Para unidades: usa o valor já calculado pela API (em M³)
          totalEstimated += item.estimatedTotal;
        }
        // Se não tem estimatedTotal mas tem readings, é um resume de setor
        else if (item.hasOwnProperty('readings') && Array.isArray(item.readings)) {
          // Para setores: soma apenas leituras com isEstimative=true
          const estimatedFromReadings = item.readings
            .filter(reading => reading.isEstimative === true)
            .reduce((sum, reading) => {
              // reading.water já está no formato correto (M³ ou litros conforme unitMeasurement)
              const value = Number(reading.water) || 0;
              return sum + value;
            }, 0);

          totalEstimated += estimatedFromReadings;
        }
      }

      return this.formatConsumption(totalEstimated);
    },

    closeInfoData() {
      this.unitSelectedDataKPIs = {}
      this.data_abstract_client = {
        name: "Selecione um cliente",
        consumptionType: "-/-",
        registry: "-",
        address: "-",
        last_updated: "-"
      };
      this.isDataGraphic = false;
      this.isDataTable = false;

    },
    async onChangeInfoUnit(unitData) {
      const formatValue = (value) => {
        return new Intl.NumberFormat('pt-BR').format(value);
      }
      this.averageBeforeFozRaw = undefined
      const unitSelected = unitData.unit
      if (!this.selectedSector || this.selectedSector.length === 0) {
        this.recordedConsumption = "Selecione um setor";
      }
      this.unitSelectedDataKPIs.goalEconomy = unitSelected && unitSelected.goalEconomy === undefined ? 'Não há dados' : (unitSelected ? unitSelected.goalEconomy : 'Não há dados');

      if (unitSelected.averageBeforeFoz !== undefined) {
        this.averageBeforeFozRaw = unitSelected.averageBeforeFoz || undefined;
        this.metaEconomy = unitSelected.metaEconomia / 100
        this.updateAdjustedAverage();
      }
      this.unitSelectedDataKPIs.goalPercentage = `${formatValue(unitSelected.metaEconomia)} %`
      this.unitSelectedDataKPIs.consumptionType = `${unitSelected.tarrifsTypes.water.tariffType} / ${unitSelected.tarrifsTypes.sewer.tariffType}`
      await this.consultConsumptionGraphic()
      this.isDataGraphic = true
    },
    async startConsultTable() {
      this.graphicFlag = false;
      this.consultTable = false;
      this.consultGraph = false;
      this.isDataGraphic = false;
      this.isDataTable = false;
      // Ativa flags que permite fazer a impressão e também flag de carregamento dos dados (vue loading)
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;

      // Bloqueio: não permitir tabela com múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível gerar tabela para múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return;
      }

      this.loadingReadings = true;
      this.readings_table = []
      this.validDayPeriodSelected = true;
      this.validHourPeriodSelected = true;
      this.validMonthPeriodSelected = true;


      this.consultDatalLoading.readingButton = true
      await this.generateAllConsumption(false)
      this.consultDatalLoading.readingButton = false

      this.readings_table = ConsumptionFunctions.createDataTable(this.resume)

      if (this.isCubicMetersSelected) {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (m³)', value: 'value', align: 'center', },
        ]
      } else {
        this.headers_tabledays = [
          { text: 'Data', align: 'center', sortable: false, value: 'date' },
          { text: 'Medição (L)', value: 'value', align: 'center', },
        ]
      }
      this.consultReading = false;
      this.isDataGraphic = false;        // Não exibe gráfico
      this.isDataTable = true;
      this.consultGraph = false;
      this.loadingReadings = false;
      this.selectsModal = false


    },
    getResumeData(modemId, key) {
      if (modemId === "groupReadings" || modemId === "somaTotal") {
        return null;
      }
      if (!this.resume.hasOwnProperty(modemId)) throw new Error(`Não foi encontrado o modem '${modemId}' no resumo dos dados`)
      let resumeModem = this.resume[modemId]
      if (!resumeModem.hasOwnProperty(key)) throw new Error(`Não foi encontrado o dado '${key}' no resumo dos dados`)
      return resumeModem[key]
    },
    generateModemIds() {
      let modems = []
      if (!Array.isArray(this.selectedSector)) {
        modems.push(this.selectedSector)
      } else {
        modems = this.selectedSector
      }
      let modemIds = modems.map((modem) => modem.id_modem)
      return modemIds
    },
    getPeriod() {
      let startDate = null
      let endDate = null
      const { period, startDate: localStartDate, endDate: localEndDate } = this.$store.getters.selectedPeriodValue || {};
      if (period === 'estimed' && this.selectedUnitSum.length > 1) {
        this.resetStateForEstimated();
        showInfoSnackBar(
          "O período estimado permite apenas uma unidade. As seleções foram redefinidas."
        );
        return { startDate: null, endDate: null };
      }
      this.selectedPeriod = period
      // Se período selecionado foi 'Últimos 7 dias'
      if (period == '7days') { // ok
        this.dateOptions.startDate = Utils.add_day(Utils.getMidnightToday(), -7)
        this.dateOptions.endDate = Utils.getLastDateOfDay(Utils.subtractDate(Utils.getMidnightToday(), 1, 'day'))
        this.dateOptions.mode = "day";
        // Convertendo para o intervalo correspondente
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else if (period == 'day') { // ok
        // Trata o mês ao qual o usuário selecionou.
        this.yearSelected = parseInt(this.yearSelected);
        this.dateOptions.startDate = Utils.instanceDate(`${localStartDate.getFullYear()}-${localStartDate.getMonth() + 1}`);
        startDate = this.dateOptions.startDate
        this.dateOptions.endDate = Utils.getLastDayOfMonth(startDate)
        this.dateOptions.mode = "day";
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
        //`${yearSelect}-`
        endDate = Utils.getLastDateOfDay(Utils.getLastDayOfMonth(startDate))
      } else if (period == 'month') { // ok
        this.dateOptions.startDate = Utils.instanceDate(`${localStartDate.getFullYear()}-${localStartDate.getMonth() + 1}-01 00:00:00`);
        const year = localEndDate.getFullYear();
        const month = localEndDate.getMonth() + 1;
        const lastDay = new Date(year, month, 0).getDate();
        this.dateOptions.endDate = Utils.instanceDate(`${year}-${month}-${lastDay} 23:59:59`);
        this.dateOptions.mode = "month";
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
      } else if (period == 'hour') { // ok
        // Quebra data selecionada para o usuário, afim de facilitar a construção do vetor com o intervalo do gráfico.
        var dateSelect = (this.dateSelected && typeof this.dateSelected === 'string' && this.dateSelected.includes('-'))
          ? this.dateSelected.split('-')
          : [];
        // Converte cada elemento do array para inteiro.       
        const year = localStartDate.getFullYear();
        const month = localStartDate.getMonth();
        const day = localStartDate.getDate();
        // Inicializando parâmetros de data
        this.dateOptions.startDate = Utils.instanceDate(`${year}-${month + 1}-${day} 00:00:00`);
        this.dateOptions.endDate = Utils.instanceDate(`${year}-${month + 1}-${day} 23:59:59`);
        this.dateOptions.mode = "hour";
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat(((this.goalMonth / 30) / 24).toFixed(2));
      } else if (period == 'interval') { // ok     
        const yearStart = localStartDate.getFullYear();
        const monthStart = localStartDate.getMonth();
        const dayStart = localStartDate.getDate();
        const yearEnd = localEndDate.getFullYear();
        const monthEnd = localEndDate.getMonth();
        const dayEnd = localEndDate.getDate();
        this.dateOptions.startDate = Utils.instanceDate(`${yearStart}-${monthStart + 1}-${dayStart} 00:00:00`);
        this.dateOptions.endDate = Utils.instanceDate(`${yearEnd}-${monthEnd + 1}-${dayEnd} 23:59:59`);
        this.dateOptions.mode = this.optionToDisplaySelected;
        startDate = this.dateOptions.startDate
        endDate = this.dateOptions.endDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else if (period == 'estimed') { // ok
        var nullVar = null
        if (!this.selectedSector?.length) {
          //showInfoSnackBar("Selecione ao menos um setor para gerar a estimativa")
          this.consultDatalLoading.graphicButton = false
          return { nullVar, nullVar }
        }
        this.dateOptions.mode = this.optionToDisplaySelected;
        this.dateOptions.startDate = localStartDate
        this.dateOptions.endDate = localEndDate
        startDate = localStartDate
        endDate = localEndDate
        this.goalMonth = parseFloat((this.goalMonth / 30).toFixed(2));
      } else {
        throw new Error("Unidentified period")
      }
      return { startDate, endDate }
    },
    mountDataChart(resultConsumptionsUnit) {

      const labels = resultConsumptionsUnit.consumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });
      const goalValue = this.getGoalConsumptionByPeriod();
      const waterDataset = {
        label: 'Água',
        data: resultConsumptionsUnit.consumptions.map(consumption => consumption.valueWater),  // Exemplo: [10, 20, 30, 0]
        backgroundColor: '#2FA4DD',
        borderColor: '#2FA4DD',
        fill: false,
        draw: false,
        borderSkipped: false,
        // barThickness: 30,
        order: 1,
        unitMeasure: this.unitMeasureVuex
      };

      // Adicionar meta de consumo se disponível
      if (goalValue !== null && goalValue !== undefined && !isNaN(goalValue)) {
        waterDataset.goalConsumption = parseFloat(goalValue.toFixed(2));
      }

      const dataset = [
        waterDataset,
        {
          label: 'Efluentes',
          data: resultConsumptionsUnit.consumptions.map(consumption => consumption.valueSewer),  // Exemplo: [5, 0, 10, 15]
          backgroundColor: '#0A517F',
          borderColor: '#0A517F',
          fill: false,
          draw: false,
          borderSkipped: false,
          // barThickness: 30,
          order: 1
        },
        {
          label: 'Média Água',
          data: Array(labels.length).fill(resultConsumptionsUnit.totalWaterAverageCurrent), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0E76BC',
          backgroundColor: '#0E76BC',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
        // Linha média para Consumo de Esgoto
        {
          label: 'Média Efluentes',
          data: Array(labels.length).fill(resultConsumptionsUnit.totalSewerAverageCurrent), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0a317f',
          backgroundColor: '#0a317f',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
      ]

      return { labels, dataset }
    },
    shadeColor(hex, percent) {
      hex = hex.replace(/^#/, '');

      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);

      r = Math.min(255, Math.max(0, r + Math.round((255 - r) * percent / 100)));
      g = Math.min(255, Math.max(0, g + Math.round((255 - g) * percent / 100)));
      b = Math.min(255, Math.max(0, b + Math.round((255 - b) * percent / 100)));

      return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
    },

    mountGroupDataChart(allConsumptions) {
      const baseHexWater = "2FA4DD";
      const baseHexSewer = "0a317f";
      const labels = allConsumptions[0].consumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });
      const currentDate = new Date();
      const dataset = allConsumptions.flatMap((unit, index) => [
        {
          data: unit.consumptions.map(consumption => consumption.valueWater),
          label: 'Água: ' + unit.unit_name,
          backgroundColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#0ffc03', index * -30) : this.shadeColor(baseHexWater, index * -30)
          ),
          borderColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#0ffc03', index * -30) : this.shadeColor(baseHexWater, index * -30)
          ),
          stack: index,
          fill: false,
          draw: false,
          borderSkipped: false,
          order: 1,
          barPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          categoryPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          maxBarThickness: 40, // Ajuste conforme necessário
        }
        ,
        {
          label: 'Efluentes: ' + unit.unit_name,
          data: unit.consumptions.map(consumption => consumption.valueSewer),
          backgroundColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#067300', index * -30) : this.shadeColor(baseHexSewer, index * -30)
          ),
          borderColor: unit.consumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? this.shadeColor('#067300', index * -30) : this.shadeColor(baseHexSewer, index * -30)
          ),
          stack: index,
          fill: false,
          draw: false,
          borderSkipped: false,
          order: 1,
          barPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          categoryPercentage: 0.8, // Ajuste essa porcentagem conforme necessário
          maxBarThickness: 40, // Ajuste conforme necessário
        }
      ]
      )



      return { labels, dataset }
    },
    sumConsumptionsByDate(allConsumptions) {

      const consumptionMap = {};
      let totalWater = 0;
      let totalSewer = 0;

      allConsumptions.forEach(unit => {
        unit.consumptions.forEach(consumption => {
          const date = new Date(consumption.time).toISOString();
          if (!consumptionMap[date]) {
            consumptionMap[date] = { valueWater: 0, valueSewer: 0 };
          }
          consumptionMap[date].valueWater += consumption.valueWater;
          consumptionMap[date].valueSewer += consumption.valueSewer;

          totalWater += consumption.valueWater;
          totalSewer += consumption.valueSewer;
        });
      });

      const results = Object.entries(consumptionMap).map(([time, values]) => ({
        time,
        ...values
      }));

      const averageWater = results.length ? totalWater / results.length : 0;
      const averageSewer = results.length ? totalSewer / results.length : 0;
      const consumptions = {
        summedConsumptions: results,
        averageWater,
        averageSewer
      };

      const labels = consumptions.summedConsumptions.map(consumption => {
        const date = new Date(consumption.time);
        return this.formatLabelByMode(date);
      });

      const currentDate = new Date();
      const goalValueSum = this.getGoalConsumptionByPeriod();

      const waterDataset = {
        label: 'Água',
        data: consumptions.summedConsumptions.map(consumption => +(consumption.valueWater.toFixed(2))),
        backgroundColor: consumptions.summedConsumptions.map(consumption =>
          new Date(consumption.time) > currentDate ? '#0ffc03' : '#2FA4DD'
        ),
        borderColor: consumptions.summedConsumptions.map(consumption =>
          new Date(consumption.time) > currentDate ? '#0ffc03' : '#2FA4DD'
        ),
        fill: false,
        draw: false,
        borderSkipped: false,
        order: 1,
        unitMeasure: this.unitMeasureVuex
      };

      // Adicionar meta de consumo se disponível
      if (goalValueSum !== null && goalValueSum !== undefined && !isNaN(goalValueSum)) {
        waterDataset.goalConsumption = parseFloat(goalValueSum.toFixed(2));
      }

      const dataset = [
        waterDataset,
        {
          label: 'Efluentes',
          backgroundColor: consumptions.summedConsumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? '#067300' : '#0A517F'
          ),
          borderColor: consumptions.summedConsumptions.map(consumption =>
            new Date(consumption.time) > currentDate ? '#067300' : '#0A517F'
          ),
          data: consumptions.summedConsumptions.map(consumption => +(consumption.valueSewer.toFixed(2))),
          fill: false,
          draw: false,
          borderSkipped: false,
          // barThickness: 30,
          order: 1
        },
        {
          label: 'Média Água',
          data: Array(labels.length).fill(averageWater), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0E76BC',
          backgroundColor: '#0E76BC',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
        // Linha média para Consumo de Esgoto
        {
          label: 'Média Efluentes',
          data: Array(labels.length).fill(averageSewer), // Cria um array com a média repetida
          type: 'line',
          borderColor: '#0a317f',
          backgroundColor: '#0a317f',
          borderWidth: 1,
          fill: false,
          pointRadius: 0, // Remove os pontos da linha
          order: 2,
        },
      ]

      return { labels, dataset }
    },
    async generateAllConsumption(isToPredict = true) {
      const toM3 = (liters = 0) => liters / 1000;
      // Snapshot simple guard values to detect changes during async operations
      const startPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      const startSelectedCount = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
      // Defesa: se estamos no período estimado e há múltiplas unidades, não executar cálculos
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        // Informar usuário e interromper sem alterar estados para evitar corrupção
        showInfoSnackBar("Não é possível calcular múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return false;
      }

      this.generatingChart = true
      this.resume = {}
      this.readings = []
      this.estimatedTotal = undefined
      let modems = []
      const { startDate, endDate } = this.getPeriod()
      if (startDate == null || endDate == null) {
        return true
      }
      let filteredSelectedSector = this.selectedSector;
      if (Array.isArray(this.selectedSector) && Array.isArray(this.selectedUnitSum)) {
        filteredSelectedSector = this.selectedSector.filter(sector => {
          return !this.selectedUnitSum.some(unitSum => unitSum.id === sector.id_unit);
        });
      }
      if (!Array.isArray(filteredSelectedSector)) {
        modems.push(filteredSelectedSector)
      } else {
        modems = filteredSelectedSector
      }
      let { permittedStartDate, permittedEndDate, resume, labels } = await this.generateSectorConsumptionFromApi(
        startDate,
        endDate,
        modems
      )
      let datas = []
      if (this.selectedUnitSum.length > 0) {
        let adjustedEndDate = this.selectedPeriod != 'hour' ? new Date(endDate.getTime() - 24 * 60 * 60 * 1000) : endDate
        const execFuncs = this.selectedUnitSum.map(unitSum => ({
          unit_id: unitSum.id,
          unit_name: unitSum.title,
          promise: ConsumptionService.findByUnit({
            start_date: startDate,
            end_date: adjustedEndDate,
            mode: this.dateOptions.mode,
            unit_measurement: this.unitMeasureVuex,
            unit_id: unitSum.id
          })
        }))
        await Promise.all(execFuncs.map(obj => obj.promise)).then((values) => {
          datas = values.reduce((acc, value, index) => {
            const unitId = execFuncs[index].unit_id;
            const unitName = execFuncs[index].unit_name;
            const consumptions = value.data.data.consumptions || [];
            // Soma água + esgoto para o consumo total registrado
            const consumptionTotal = (value.data.data.totalWaterMeasured || 0) + (value.data.data.totalSewerMeasured || 0);
            //console.log("CONSUMPTION TOTAL FROM API", consumptionTotal);
            // Soma água + esgoto para a média
            const average = (value.data.data.totalWaterAverageCurrent || 0) + (value.data.data.totalSewerAverageCurrent || 0);
            //console.log("AVERAGE FROM API", average);
            const estimatedTotal =
              (value.data.data.totalWaterEstimatedTotal || 0) + (value.data.data.totalSewerEstimatedTotal || 0);
            //console.log("ESTIMATED TOTAL FROM API", estimatedTotal);
            acc[unitId] = {
              // IMPORTANTE: Os 3 valores abaixo SEMPRE estão em M³ (metros cúbicos)
              measured_total: toM3(consumptionTotal), // Valor medido total em M³
              average: toM3(average), // Média em M³
              estimatedTotal: toM3(estimatedTotal), // Valor estimado total em M³
              modemName: unitName,
              labels: consumptions.map(consumption => {
                const date = new Date(consumption.time);
                return this.formatLabelByMode(date);
              }),
              readings: consumptions.map(consumption => {
                const date = new Date(consumption.time);
                return {
                  date: date,
                  label: this.formatLabelByMode(date),
                  water: ((consumption.valueWater || 0) + (consumption.valueSewer || 0)) / 1000,
                  isEstimative: false
                };
              }),
              modemId: "somaTotal"
            };

            return acc;
          }, {});
        })
      }

      if (datas && Object.keys(datas).length > 0) {
        // Antes de aplicar os resultados, confirmar que o período e seleção não mudaram durante as chamadas assíncronas
        const currentPeriodAfter = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
        const currentSelectedCountAfter = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
        if ((currentPeriodAfter === 'estimed' && currentSelectedCountAfter > 1) || currentSelectedCountAfter !== startSelectedCount || currentPeriodAfter !== startPeriod) {
          return false;
        }

        this.resume = { ...resume, ...datas };
        // Usar getEstimatedTotal que já soma todos os estimatedTotal em M³ e formata para exibição
        this.estimatedTotal = this.getEstimatedTotal(this.resume);
        //console.log("RESUME UNITS", this.resume)

      } else {
        const currentPeriodAfter = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
        const currentSelectedCountAfter = Array.isArray(this.selectedUnitSum) ? this.selectedUnitSum.length : (Array.isArray(this.selectedUnits) ? this.selectedUnits.length : 0);
        if ((currentPeriodAfter === 'estimed' && currentSelectedCountAfter > 1) || currentSelectedCountAfter !== startSelectedCount || currentPeriodAfter !== startPeriod) {
          return false;
        }

        this.resume = resume;
        this.estimatedTotal = this.getEstimatedTotal(this.resume);
        //console.log("RESUME SECTOR", this.resume)
      }

      this.permittedStartDate = permittedStartDate;
      this.permittedEndDate = permittedEndDate;
      this.totalDates = labels.length;
      this.generatingChart = false
    },
    // Filtragem do consumo pelo Gráfico. Onde serão mostrados os consumos no gráfico: 
    //    por 7 dias     -> registros dos últimos 7 dias
    //    por dia        -> registros dos dias de um mês específico
    //    por hora       -> registros por hora de um dia específico
    //    por intervalo  -> registros por hora em intervalo definido
    async consultConsumptionGraphic() {
      // Bloqueio: não permitir consulta de múltiplas unidades com período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível consultar múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        // Mantém KPIs visíveis, impede atualização do gráfico
        this.isDataGraphic = false;
        this.isKPI = true;
        this.consultReading = false;
        this.loadingReadings = false;
        return;
      }

      this.generatingChart = true;
      try {
        this.graphicFlag = true;
        this.consultTable = false;
        this.isDataGraphic = false;

        if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) {
          this.generatingChart = false;
          return;
        }

        // Ativa flags que permite fazer a impressão e também flag de carregamento dos dados (vue loading)
        this.isDataTable = false;
        this.unitsDataGraphic = [];
        this.summedGraphs = [];
        this.loadingReadings = true;
        this.validDayPeriodSelected = true;
        this.validHourPeriodSelected = true;
        this.validMonthPeriodSelected = true;

        const match = String(this.adjustedAverage).match(/[\d,.]+/);
        const averageBeforeFozValue = match ? parseFloat(match[0].replace('.', '')) : 0;
        const matchGoal = String(this.unitSelectedDataKPIs.goalPercentage).match(/[\d,.]+/);
        const goalPercentageValue = matchGoal ? parseFloat(matchGoal[0].replace('.', '')) : 0;
        this.goalMonth = parseFloat((averageBeforeFozValue * ((100 - goalPercentageValue) / 100)).toFixed(2));

        this.consultDatalLoading.graphicButton = true
        var isConsumptionGenerated = await this.generateAllConsumption()
        this.consultDatalLoading.graphicButton = false

        // Se a geração foi abortada (período/seleção mudou durante as chamadas assíncronas), não continuar com recalculos
        if (isConsumptionGenerated === false) {
          this.generatingChart = false;
          this.loadingReadings = false;
          this.consultReading = false;
          this.consultGraph = false;
          this.isDataGraphic = false; // manter KPIs visíveis
          this.isKPI = true;
          return;
        }

        this.sumSingleResumeReadingsWater(this.resume);
        // Calcular meta de consumo ajustada conforme período
        const goalConsumptionValue = this.getGoalConsumptionByPeriod();
        this.readings = await ConsumptionFunctions.createDataset(this.resume, goalConsumptionValue)
        try {
          const recordedBase = this.recordedConsumptionRaw || 0;
          const average = this.getAverageConsumption(this.resume)
          const labelsLength = (this.readings && this.readings[0] && Array.isArray(this.readings[0].labels)) ? this.readings[0].labels.length : 0;
          if (labelsLength > 0) {
            this.averageConsumption = this.formatConsumption(average);
          }
          this.recordedConsumption = this.formatConsumption(recordedBase);
        } catch (err) {
          console.warn('Não foi possível recalcular KPIs após leitura do gráfico', err)
        }
        const resumeKeys = Object.keys(this.resume).filter(key => key !== 'goal');
        this.dynamicHeight = '80vh'
        this.isKPI = true
        if (resumeKeys.length > 1 && !this.resume?.goal) {
          this.resume.groupReadings = {
            modemName: "DADOS AGRUPADOS",
          };
          this.readings = [this.groupReadings()]

          // if (!this.checkSameUnit()) {
          //   this.dynamicHeight = '90vh'
          //   this.isKPI = false
          // }
        }

        this.consultReading = false;
        this.loadingReadings = false;
        this.consultGraph = false;        // Fecha modal de gráfico
        if (isConsumptionGenerated) {
          this.selectsModal = true
        } else {
          this.isDataGraphic = true;        // Exibe gráfico  
          this.selectsModal = false
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.generatingChart = false;
      }
    },
    async startPdf() {
      if (this.selectedSector.length === 0) {
        showInfoSnackBar("Nenhum setor encontrado para gerar o PDF")
        return
      }
      try {
        await this.getPeriod()
      } catch (error) {
        console.error('Error getting period: ', error)
      }
      if (this.$refs.formConsumption && !this.$refs.formConsumption.validate()) return;

      // Bloqueio: não permitir gerar PDF para múltiplas unidades quando período estimado
      const currentPeriod = this.$store.getters.selectedPeriodValue?.period || this.selectedPeriod;
      if (currentPeriod === 'estimed' && Array.isArray(this.selectedUnitSum) && this.selectedUnitSum.length > 1) {
        showInfoSnackBar("Não é possível gerar PDF para múltiplas unidades com o período 'Estimado'. Selecione apenas uma unidade ou altere o período.");
        return;
      }

      try {
        if (!this.checkSameUnit()) {
          showInfoSnackBar("Selecione apenas uma unidade para gerar o PDF")
          return
        }
        this.loadButtonPdf = true
        this.exporting = true
        //body passado para a API PDF
        const params = {
          selectedSector: this.selectedSector,
          period: this.selectedPeriod,
          currentUserId: store.state.currentUser?.uid,
          unitId: this.selectedUnits[0],
          modemIds: this.selectedSector.map(sector => sector.id_modem),
          unitMeasurement: this.unitMeasureVuex,
          isUnit: this.selectedUnitSum.length > 0 ? true : false,
          ...this.dateOptions
        }
        const response = await ConsumptionApi.generateConsumptionPdf(params)
        this.dialogDownload = true
        this.fileLink = response.data.signedUrl
        this.exporting = false

      } catch (error) {
        console.error(error)
        showErrorSnackBar("Erro ao gerar PDF! Entre em contato com nossa equipe!")
        this.exporting = false
      } finally { this.loadButtonPdf = false }
    },
    formatDate(date) {
      if (!date || typeof date !== 'string' || !date.includes('-')) return null;
      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    async getPreviewDate() {
      try {
        const today = new Date();
        const unitSelected = this.listUnits.find(({ id }) => id === this.selectedUnits[0])
        if (unitSelected != undefined && typeof unitSelected.lastReadingDate != "undefined") {
          this.lastReadingDate = (new Date(unitSelected.lastReadingDate._seconds * 1000 + unitSelected.lastReadingDate._nanoseconds / 1e6))
          this.previewDate = new Date(this.lastReadingDate)
          while (this.previewDate <= today) {
            this.previewDate.setMonth(this.previewDate.getMonth() + 1)
          }
          this.previewDateCurrent = new Date(this.previewDate)
          this.previewDateCurrent.setDate(this.previewDate.getDate() - 30)
          this.dateFormattedSelectedPreviewStart = Utils.formatDate(this.previewDateCurrent, "<dd>/<MM>/<YYYY>")
          this.dateFormattedSelectedPreviewEnd = Utils.formatDate(this.previewDate, "<dd>/<MM>/<YYYY>")
        } else {
          this.dateFormattedSelectedPreviewStart = ''
          this.dateFormattedSelectedPreviewEnd = ''
          return
        }
      } catch (err) {
        console.error(err)
        showInfoSnackBar(err)
      }
    },
    debouncedGetSectors: debounce(function (e) {
      this.onChangeUnit(e);
    }, 1000),
    getGoalConsumptionByPeriod() {
      // Retorna a meta de consumo ajustada conforme o período selecionado
      // A meta de consumo mensal é: averageBeforeFoz * (1 - metaEconomy)
      // Só retorna a meta se uma unidade INTEIRA estiver selecionada (não apenas setores)
      if (!this.selectedUnitSum || this.selectedUnitSum.length === 0) {
        return null;
      }
      if (this.averageBeforeFozRaw === undefined || this.metaEconomy === undefined) {
        return null;
      }

      const unitMeasure = this.unitMeasureVuex;
      const goalConsumptionMonthly = this.averageBeforeFozRaw * (1 - this.metaEconomy);

      // Converter para litros se necessário
      const goalConsumptionMonthlyValue = unitMeasure === 'liters' ? goalConsumptionMonthly * 1000 : goalConsumptionMonthly;

      // Ajustar conforme o período selecionado
      const period = this.selectedPeriod;
      const mode = this.dateOptions?.mode || 'day';
      let adjustedGoal = goalConsumptionMonthlyValue;

      if (period === '7days') {
        // Últimos 7 dias: meta mensal / 30 (meta diária)
        adjustedGoal = goalConsumptionMonthlyValue / 30;
      } else if (period === 'day') {
        // Por dia: meta mensal / 30
        adjustedGoal = goalConsumptionMonthlyValue / 30;
      } else if (period === 'hour') {
        // Por hora: meta mensal / 30 / 24
        adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
      } else if (period === 'month') {
        // Por mês: meta mensal (sem ajuste)
        adjustedGoal = goalConsumptionMonthlyValue;
      } else if (period === 'interval' || period === 'estimed') {
        // Por intervalo ou período estimado: depende do modo (day, hour ou month)
        if (mode === 'hour') {
          adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
        } else if (mode === 'day') {
          adjustedGoal = goalConsumptionMonthlyValue / 30;
        } else if (mode === 'month') {
          adjustedGoal = goalConsumptionMonthlyValue;
        }
      } else {
        // Fallback: usar o modo se o período não for reconhecido
        if (mode === 'hour') {
          adjustedGoal = (goalConsumptionMonthlyValue / 30) / 24;
        } else if (mode === 'day') {
          adjustedGoal = goalConsumptionMonthlyValue / 30;
        } else if (mode === 'month') {
          adjustedGoal = goalConsumptionMonthlyValue;
        }
      }

      return adjustedGoal;
    },
    updateAdjustedAverage() {
      const formatValue = (value) => {
        return new Intl.NumberFormat('pt-BR').format(value);
      }
      const unitMeasure = this.unitMeasureVuex;
      let adjusted = this.averageBeforeFozRaw;
      let recorded = this.recordedConsumptionRaw
      let suffix = 'M³';
      if (unitMeasure === 'liters') {
        adjusted = this.averageBeforeFozRaw !== undefined ? this.averageBeforeFozRaw * 1000 : 'Não há dados';
        recorded = this.recordedConsumptionRaw !== undefined ? this.recordedConsumptionRaw * 1000 : 'Não há dados';
        suffix = 'L';
      }
      const goalEconomyValue = adjusted - (adjusted * this.metaEconomy);
      this.goalEconomy = isNaN(goalEconomyValue) ? 'Não há dados' : `${formatValue(goalEconomyValue)} ${suffix}`;
      this.adjustedAverage = isNaN(adjusted) ? 'Não há dados' : `${formatValue(adjusted)} ${suffix}`;
      if (recorded == undefined) this.recordedConsumption = 'Selecione um setor';
      else this.recordedConsumption = `${recorded.toLocaleString('pt-BR', { maximumFractionDigits: 2 })} ${suffix}`;
      this.goalEconomy = this.goalEconomy || '';
      this.adjustedAverage = this.adjustedAverage || '';
      this.recordedConsumption = this.recordedConsumption || ''
    },
    sumReadingsByIndex(resume) {
      // Nova lógica: somar resume[<id>].readings[m].water para todos os resumes e todos os m
      // Ignorar a chave 'goal'
      const validItems = Object.entries(resume)
        .filter(([key, value]) => key !== 'goal' && value && Array.isArray(value.readings))
        .map(([_, value]) => value);
      if (validItems.length === 0) return { readings: [], labels: [] };
      // Descobrir o maior número de readings
      const maxLen = Math.max(...validItems.map(item => item.readings.length));
      const summed = [];
      for (let i = 0; i < maxLen; i++) {
        let sum = 0;
        for (let item of validItems) {
          const arr = item.readings;
          // Somar o .water se existir
          if (arr[i] && typeof arr[i].water === 'number') {
            sum += arr[i].water;
          } else if (arr[i] && typeof arr[i].water_liters === 'number') {
            sum += arr[i].water_liters;
          } else if (arr[i] && typeof arr[i].value === 'number') {
            sum += arr[i].value;
          }
        }
        summed.push({ water: sum });
      }
      let anyLabels = null;
      for (const item of validItems) {
        if (Array.isArray(item.labels)) {
          anyLabels = [...item.labels];
          break;
        }
      }
      return { readings: summed, labels: anyLabels };
    },
    // Retorna a média de consumo (em M³) do resume
    // Suporta tanto resume de unidades quanto de setores
    getAverageConsumption(resume) {
      if (!resume || typeof resume !== 'object') return 0;
      const keys = Object.keys(resume).filter(k => k !== 'goal');
      if (!keys.length) return 0;
      // resume unit 
      if (keys.length === 1) {
        const key = keys[0];
        return resume[key]?.average || 0; // Valor em M³
      }

      // sectors resume - soma todas as médias
      let total = 0;
      keys.forEach(key => {
        const avg = resume[key]?.average;
        if (typeof avg === 'number') {
          total += avg;
        }
      });
      return total; // Valor em M³
    },



    // Extrai e soma measured_total (em M³) do resume para calcular consumo registrado
    // IMPORTANTE: O valor armazenado em recordedConsumptionRaw está SEMPRE em M³
    sumSingleResumeReadingsWater(resume) {
      const keys = Object.keys(resume).filter(k => k !== 'goal');
      this.recordedConsumptionRaw = 0;
      if (keys.length > 1) {
        let waterGroup = 0;
        for (let n = 0; n < keys.length; n++) {
          const key = keys[n];
          this.sumSingleResumeReadingsWater({ [key]: resume[key] });
          waterGroup += this.recordedConsumptionRaw || 0;
        }
        this.recordedConsumptionRaw = waterGroup;
        this.updateAdjustedAverage();
        return;
      }
      if (keys && resume[keys]) {
        this.recordedConsumptionRaw = resume[keys].measured_total || 0;
      } else {
        this.recordedConsumptionRaw = 0;
      }
      this.updateAdjustedAverage();
    },
    checkSameUnit() {
      if (this.selectedUnitSum.length > 1) return false;
      const firstUnitId = this.selectedSector[0].id_unit;
      const selectedUnitSumVerify = firstUnitId == this.selectedUnitSum[0]?.id || this.selectedUnitSum.length == 0;
      return this.selectedSector.every(sector => sector.id_unit === firstUnitId) && selectedUnitSumVerify;
    },
    groupReadings() {

      // Função para gerar cores derivadas de azul
      const generateBlueVariation = (index, total) => {
        // Base azul principal
        const baseBlue = { r: 64, g: 146, b: 255 }; // #4092FF

        const blueVariations = [
          { r: 64, g: 146, b: 255 },   // Azul original
          { r: 0, g: 46, b: 113 },     // Azul escuro
          { r: 0, g: 172, b: 193 },    // Azul ciano
          { r: 32, g: 73, b: 128 },    // Azul médio
          { r: 0, g: 123, b: 255 },    // Azul claro
          { r: 25, g: 118, b: 210 },   // Azul material
          { r: 0, g: 150, b: 136 },    // Verde azulado
          { r: 48, g: 63, b: 159 },    // Índigo
          { r: 0, g: 87, b: 183 },     // Azul profundo
          { r: 96, g: 125, b: 139 },   // Azul acinzentado
        ];
        // Se temos variações suficientes, usar elas
        if (index < blueVariations.length) {
          const color = blueVariations[index];
          return `#${color.r.toString(16).padStart(2, '0')}${color.g.toString(16).padStart(2, '0')}${color.b.toString(16).padStart(2, '0')}`.toUpperCase();
        }
        const hue = 210 + (index * 15) % 60; // Varia entre 210-270 (tons de azul)
        const saturation = 70 + (index * 5) % 30; // 70-100%
        const lightness = 40 + (index * 8) % 40; // 40-80%
        // Converter HSL para RGB
        const h = hue / 360;
        const s = saturation / 100;
        const l = lightness / 100;
        const c = (1 - Math.abs(2 * l - 1)) * s;
        const x = c * (1 - Math.abs((h * 6) % 2 - 1));
        const m = l - c / 2;
        let r, g, b;
        if (h < 1 / 6) {
          r = c; g = x; b = 0;
        } else if (h < 2 / 6) {
          r = x; g = c; b = 0;
        } else if (h < 3 / 6) {
          r = 0; g = c; b = x;
        } else if (h < 4 / 6) {
          r = 0; g = x; b = c;
        } else if (h < 5 / 6) {
          r = x; g = 0; b = c;
        } else {
          r = c; g = 0; b = x;
        }
        const rHex = Math.round((r + m) * 255).toString(16).padStart(2, '0');
        const gHex = Math.round((g + m) * 255).toString(16).padStart(2, '0');
        const bHex = Math.round((b + m) * 255).toString(16).padStart(2, '0');
        return `#${rHex}${gHex}${bHex}`.toUpperCase();
      };

      if (!Array.isArray(this.selectedSector) || !Array.isArray(this.readings)) return { datasets: [], labels: [] };
      const datasets = this.readings.map((sector, n) => {
        if (!this.readings[n] || !this.readings[n].datasets || !this.readings[n].datasets[0]) return null;
        const dataset0 = this.readings[n].datasets[0];
        const dataset1 = this.readings[n].datasets[1];
        const datasetCopy = JSON.parse(JSON.stringify(dataset0));
        if (dataset1 && Array.isArray(dataset0.data) && Array.isArray(dataset1.data)) {
          datasetCopy.data = dataset0.data.map((val, idx) => {
            const val1 = typeof parseFloat(val) === 'number' ? parseFloat(val) : 0;
            const val2 = typeof parseFloat(dataset1.data[idx]) === 'number' ? parseFloat(dataset1.data[idx]) : 0;
            return val1 + val2;
          });
        }
        datasetCopy.label = this.getResumeData(this.readings[n].modemId, 'modemName');
        delete datasetCopy.order;
        delete datasetCopy.stack;
        datasetCopy.backgroundColor = generateBlueVariation(n, this.readings.length);
        datasetCopy.barPercentage = 0.8;
        datasetCopy.categoryPercentage = 0.8;
        return datasetCopy;
      }).filter(Boolean);
      return {
        datasets,
        labels: this.readings[0] && this.readings[0].labels ? this.readings[0].labels : [],
        modemId: "groupReadings"
      };
    },
  },

  watch: {
    optionMetric() {
      if (this.optionMetric == true) {
        this.switch1 = "Metros Cúbicos (m³)";
      } else {
        this.switch1 = "Litros (L)";
      }
    },
    dateSelectedEnd() {
      this.dateFormattedSelectedEnd = this.formatDate(this.dateSelectedEnd);
    },
    dateSelectedStart() {
      this.dateFormattedSelectedStart = this.formatDate(this.dateSelectedStart);
    },
    dateSelectedPreviewEnd() {
      this.dateFormattedSelectedPreviewEnd = this.formatDate(this.dateSelectedPreviewEnd);
    },
    dateSelectedPreviewStart() {
      this.dateFormattedSelectedPreviewStart = this.formatDate(this.dateSelectedPreviewStart);
    },
    dateSelected() {
      this.dateSelectedFormatted = this.formatDate(this.dateSelected);
    },
    optionPeriod() {
      this.getPreviewDate()
    },
    selectedSector() {
      this.getPreviewDate()
    },
    getSelectedUnit: {
      immediate: true,
      handler(newUnit) {
        if (newUnit) {
          this.selectedUnits = [newUnit.id];
          this.debouncedGetSectors(newUnit);
          // this.onChangeInfoUnit(newUnit);
        }
      }
    },
    getSelectedSectors(newSectors) {
      this.syncSelectedSectorsFromVuex();
    },
    // Watcher para sincronizar unidades selecionadas do Vuex
    getSelectedUnits: {
      immediate: true,
      handler(newSum) {
        if (newSum && Array.isArray(newSum)) {
          this.selectedUnitSum = [...newSum];
          this.consultConsumptionGraphic()
        }
      }
    },
    unitMeasureVuex(newVal) {
      this.updateAdjustedAverage();
      this.consultConsumptionGraphic()
    },
    selectedPeriodValueVuex(newVal) {
      this.consultConsumptionGraphic()
    }
  },
  async created() {
    this.selectsLoading.client = true
    const response = await UsersService.findAllClients()
    this.listClients = response.data.data
    this.selectsLoading.client = false
    if (this.listClients.length === 1) {
      this.selectedClient = this.listClients[0]
      await this.onChangeClient(this.selectedClient.id)
    }
    await this.syncSelectedSectorsFromVuex();
    // Se houver uma unidade já selecionada na RightSidebar ao entrar na tela de Consumo,
    // garante que seus setores (não RESERVOIR) sejam automaticamente selecionados.
    await this.ensureSectorsForSelectedUnitIfMissing();
  },
};
